'use strict';

var $ = require('jquery');
var globalisation = require('../../utilities/globalisation');
var utilities = require('../utilities');

exports.passwordPattern =  function(value, element) {
  return utilities.isValidPassword($(element).val());
};

$.validator.addMethod('password-pattern', exports.passwordPattern, globalisation.pluraliseAndTranslate('account', 'passwordRequirements'));



// WEBPACK FOOTER //
// ./assets/js/validators/password-pattern.js